import React from "react";
import AboutHeader from "./Component/Aboute/AboutHeader/AboutHeader";
import SmartLife from "./Component/Aboute/SmartLife/SmartLife";
import Team from "./Component/Aboute/Team/Team";

function Aboute() {
  return (
    <>
      <AboutHeader />
      <SmartLife />
      <Team />
    </>
  );
}

export default Aboute;
